import { useState, useEffect } from 'react';
import WholesaleLayout, { useWholesaleAuth, StatusBadge } from './WholesaleLayout';
import { getWholesaleOrders } from '../../lib/api';

const API = process.env.REACT_APP_BACKEND_URL;

export default function WholesaleOrders() {
  const user = useWholesaleAuth('wholesale');
  const [orders, setOrders] = useState([]);

  useEffect(() => { if (user) getWholesaleOrders().then(r => setOrders(r.data)).catch(() => {}); }, [user]);

  const token = localStorage.getItem('auth_token');

  return (
    <WholesaleLayout user={user} title="My Orders">
      {orders.length === 0 && <div style={{ textAlign:'center', color:'#888', padding:80, fontSize:14 }}>No orders yet. Browse the catalogue to place your first order.</div>}
      {orders.map(o => (
        <div key={o.id} data-testid={`order-card-${o.id}`} style={{ background:'#fff', border:'1px solid #E0DED8', borderRadius:4, padding:24, marginBottom:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div>
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:18, fontWeight:700, letterSpacing:1 }}>{o.id}</span>
              <span style={{ marginLeft:12, fontSize:12, color:'#888' }}>{new Date(o.created_at).toLocaleDateString()}</span>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <StatusBadge status={o.status} />
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:20, fontWeight:700 }}>${o.total?.toLocaleString()}</span>
            </div>
          </div>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
            <thead>
              <tr>
                {['Item','Price','Qty','Total'].map(h => <th key={h} style={{ padding:'10px 12px', fontSize:10, letterSpacing:1.5, textTransform:'uppercase', color:'#888', borderBottom:'2px solid #E0DED8', fontWeight:600, textAlign:'left' }}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {(o.items || []).map((it, i) => (
                <tr key={i}><td style={td}>{it.name}</td><td style={td}>${Number(it.price).toLocaleString()}</td><td style={td}>{it.qty}</td><td style={td}>${(it.price * it.qty).toLocaleString()}</td></tr>
              ))}
            </tbody>
          </table>
          {o.notes && <div style={{ marginTop:12, padding:'10px 14px', background:'#F7F6F2', borderRadius:2, fontSize:13, color:'#555' }}>{o.notes}</div>}
          {o.tracking && <div style={{ marginTop:10, display:'inline-block', padding:'4px 12px', background:'#111', color:'#fff', borderRadius:2, fontSize:11, letterSpacing:1 }}>TRACKING: {o.tracking}</div>}
          <div style={{ marginTop:16 }}>
            {['approved','paid','shipped'].includes(o.status) ? (
              <a href={`${API}/api/wholesale/invoice/pi/${o.id}?token=${token}`} target="_blank" rel="noreferrer"
                style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'8px 16px', fontFamily:'Barlow', fontSize:12, fontWeight:600, letterSpacing:1, textTransform:'uppercase', borderRadius:2, cursor:'pointer', background:'transparent', color:'#111', border:'1.5px solid #111', textDecoration:'none' }}>
                Download Proforma Invoice
              </a>
            ) : (
              <span style={{ fontSize:12, color:'#aaa' }}>Invoice available once order is approved.</span>
            )}
          </div>
        </div>
      ))}
    </WholesaleLayout>
  );
}

const td = { padding:'12px', borderBottom:'1px solid #E0DED8', verticalAlign:'middle' };
